// extracted by mini-css-extract-plugin
export default {"page":"styles_page__4HJZH","title":"styles_title__LEYvH","text":"styles_text__DXpY2"};